import React from 'react';

export const BackSlideSvg: React.FC<React.SVGProps<SVGSVGElement>> = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.72005 7.94409L8.26334 13.6051C8.38488 13.7302 8.52948 13.8295 8.6888 13.8973C8.84811 13.9651 9.01899 14 9.19158 14C9.36417 14 9.53506 13.9651 9.69437 13.8973C9.85369 13.8295 9.99829 13.7302 10.1198 13.6051C10.3633 13.3549 10.5 13.0165 10.5 12.6638C10.5 12.3111 10.3633 11.9727 10.1198 11.7225L5.4917 6.99614L10.1198 2.26976C10.3633 2.0196 10.5 1.68121 10.5 1.32848C10.5 0.975759 10.3633 0.637366 10.1198 0.387212C9.99766 0.263469 9.85278 0.165571 9.6935 0.0991281C9.53421 0.0326855 9.36364 -0.000992724 9.19158 2.31722e-05C9.01952 -0.000992724 8.84896 0.0326855 8.68967 0.0991281C8.53038 0.165571 8.38551 0.263469 8.26334 0.387212L2.72005 6.04819C2.59752 6.17231 2.50025 6.31998 2.43388 6.48268C2.36751 6.64538 2.33333 6.81989 2.33333 6.99614C2.33333 7.17239 2.36751 7.3469 2.43388 7.5096C2.50025 7.6723 2.59752 7.81997 2.72005 7.94409Z"
      fill="#282F33"
    />
  </svg>
);

export default BackSlideSvg;
